import ConfigurableBackground from './_configurable-background.js'
import ConfigurableBorder from './_configurable-border.js'
import CrossSellMenu from './_cross-sell-menu.js'
import Image from './_image.js'
import Button from './_button.js'
import SystemInitialisation from './_system-initialisation.js'
import FlexPane from './_flex-pane.js'

export default {
  name: 'ApplicationMenu',
  values: {
    showCompactLayout: false,
    _mobile_showCompactLayout: true,
    style: {
      container: {
        maxWidth: '100%',
        _desktop_maxWidth: '1440px',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      innerContainer: {
        flexBasis: '64px',
        _mobile_flexBasis: '48px',
        $mixin: [
          {
            configSet: ConfigurableBorder,
          },
        ],
      },
      sideColumns: {
        flexBasis: '20%',
      },
    },
    layout: 'multi-row',
    singleRowLayout: {
      crossSellMenu: {
        configSet: CrossSellMenu,
        configValues: {
          container: {
            style: {
              flexBasis: '60%',
            },
          },
          linkButtons: {
            container: {
              style: {
                justifyContent: 'center',
              },
            },
            selectableButton: {
              unselected: {
                style: {
                  base: {
                    alignItems: 'center',
                  },
                },
              },
              selected: {
                style: {
                  base: {
                    alignItems: 'center',
                  },
                },
              },
            },
          },
          linkHighlightIconContainer: {
            style: {
              right: '-10px',
            },
          },
        },
      },
    },
    multiRowLayout: {
      crossSellMenu: {
        configSet: CrossSellMenu,
        configValues: {},
      },
    },
    showCrossSellMenu: true,
    _mobile_showCrossSellMenu: false,
    logo: {
      configSet: Image,
      configValues: {
        style: {
          flexGrow: 1,
          width: '100%',
          height: '40px',
          _mobile_height: '100%',
        },
      },
    },
    logoButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: '176px',
            _mobile_flexBasis: '118px',
            alignSelf: 'stretch',
            padding: '0 0 0 16px',
            _mobile_padding: '0 0 0 8px',
            flexDirection: 'column',
          },
        },
      },
    },
    showSystemInitialisation: true,
    _mobile_showSystemInitialisation: false,
    systemInitialisation: {
      configSet: SystemInitialisation,
      configValues: {},
    },
    rightColumnCompact: {
      configSet: FlexPane,
      configValues: {},
    },
    showSearch: false,
    _mobile_showSearch: false,
    searchIcon: {
      configSet: Image,
      configValues: {
        src: 'system-search',
        style: {
          minWidth: '20px',
          minHeight: '20px',
        },
      },
    },
    searchButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexBasis: '40px',
            padding: '0 8px 0 0',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
